import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'

import { Tool } from '@cyborg-monorepo/hunter/common'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

@Injectable({
  providedIn: 'root',
})
export class ToolService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  private apiUrl: string = this.verityEnvironmentService.apiUrl + '/v2'

  public createTool(tool: Partial<Tool>): Observable<Tool> {
    return this.httpClient.post<Tool>(`${this.apiUrl}/tool/`, tool)
  }

  public getToolById(id: string): Observable<Tool> {
    return this.httpClient.get<Tool>(`${this.apiUrl}/tool/${id}`)
  }

  public updateTool(id: string, toolData: Partial<Tool>): Observable<Tool> {
    return this.httpClient.put<Tool>(`${this.apiUrl}/tool/${id}`, toolData)
  }

  public deleteTool(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/tool/${id}`)
  }
}
